import { render, staticRenderFns } from "./OnSign.vue?vue&type=template&id=0e785920"
import script from "./OnSign.vue?vue&type=script&lang=js"
export * from "./OnSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports